import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcGenericListItemDto, FcModifyGenericListItemDto } from 'webcommon/shared';

import {
  FcGenericItemModalBaseComponent,
  FcListValidationService,
} from '../../generic/index';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-generic-list-modal',
  templateUrl: './fc-generic-list-modal.component.html',
})
export class FcGenericListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-item';

  // List Item with default value
  public listItem: FcGenericListItemDto = {
    Id: '',
    ExternalID: '',
    Name: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
  };

  // Form Controls
  public externalIdControl: FormControl = new FormControl('');
  public nameControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl('');
  public inactiveControl: FormControl = new FormControl(false);
  public userDefinedControl: FormControl = new FormControl(true);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    // External ID Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem.ExternalID);

    // Name Control
    const isNameControlDisabled = !this.listItem.UserDefined;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyGenericListItemDto = {
      ExternalID: values.externalId,
      Name: values.name,
      Inactive: values.inactive,
      Notes: values.notes,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyGenericListItemDto>(modifyItemDto);
  }
}
